module.exports = __webpack_public_path__ + "img/grade-4-1.8411758b.png";